import styled from '@emotion/styled';
import { animateDarkBg, textureSvg } from '@shared/constants/Styles';

export const TexturedBackground = styled.div`
    // height minus the height of the footer and toolbar
    min-height: calc(100vh - 186px);
    width: 100%;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    justify-content: space-between;
    animation-name: ${animateDarkBg};
    animation-duration: 300ms;
    :before {
        z-index: -1;
        background-image: ${textureSvg};
        background-size: 100% 100%;
        position: fixed;
        top: 60vh;
        right: -60vw;
        display: inline-block;
        height: 1500px;
        width: 1500px;
        content: '';
    }
    :after {
        z-index: -1;
        transform: rotate(180deg);
        background-image: ${textureSvg};
        background-size: 100% 100%;
        position: fixed;
        top: -1000px;
        left: -70vw;
        display: inline-block;
        height: 1500px;
        width: 1500px;
        content: '';
    }
`;
